import UAParser from 'ua-parser-js'
import _ from 'lodash'

const supportedBrowsers = {
  chrome: '68',
  firefox: '70',
  safari: '11',
  edge: '70',
  'mobile safari': '12 '
}

function getUserAgent(providedUserAgent) {
  const parser = new UAParser(providedUserAgent)
  return parser.getResult()
}

const getBrowserDetails = providedUserAgent => {
  const userAgent = getUserAgent(providedUserAgent)

  const currentBrowser = _.get(userAgent, ['browser', 'name'], '')
  const currentBrowserVersion = _.get(userAgent, ['browser', 'major'], 0)
  const supportedBrowserVersion = _.get(
    supportedBrowsers,
    [_.toLower(currentBrowser)],
    1
  )
  const OSName = _.get(userAgent, ['os', 'name'])
  const OSVersion = _.get(userAgent, ['os', 'version'])

  return {
    check:
      parseInt(currentBrowserVersion, 10) >=
      parseInt(supportedBrowserVersion, 10),
    name: currentBrowser,
    version: currentBrowserVersion,
    OSName,
    OSVersion
  }
}

export { getUserAgent, getBrowserDetails }
